import axios from "axios";
import { DataGrid, DropDownBox } from "devextreme-react";
import {
  Column,
  FilterRow,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Scrolling,
  Selection,
} from "devextreme-react/data-grid";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateTaskList } from "./Redux/taskList";
import { updateCodeNo } from "./Redux/workRecord";
import {
  compareTaskCategories,
  taskListCacheKey,
  taskListDate,
  taskSelectionKey,
  taskSelectionRows,
} from "./taskSelection";

export default function TaskDropDownBox(props) {
  const {
    taskDropDownBoxRef,
    //  currentEmployeeNo
    currentEmployee,
  } = props;

  const workRecord = useSelector((state) => state.workRecord);

  const [isTaskGridBoxOpened, setIsTaskGridBoxOpened] = useState(false);
  const [taskListDataSource, setTaskListDataSource] = useState(null);

  const dispatch = useDispatch();

  const taskList = useSelector((state) => state.taskList);
  const userInfo = useSelector((state) => state.userInfo);
  const classifWork = useSelector((state) => state.workRecord.classifWork);
  const defaultQuote = classifWork == 2 ? currentEmployee.div : "";
  const taskRows = useMemo(
    () => taskSelectionRows(taskListDataSource, defaultQuote),
    [taskListDataSource, defaultQuote]
  );
  const selectedTaskKey = taskSelectionKey(
    workRecord.quotNo || defaultQuote,
    workRecord.codeNo
  );

  const taskDropDownDataGridRef = useRef(null);

  const contrNo = Array.isArray(workRecord.contrNo)
    ? workRecord.contrNo[0]
    : workRecord.contrNo;
  const taskDate = taskListDate(workRecord.startDate);
  const { div, employeeNo } = currentEmployee;
  const taskListKey = classifWork == 2
    ? JSON.stringify(["department", div])
    : taskListCacheKey(contrNo, div, taskDate, employeeNo);
  const cachedTasks = taskList[taskListKey];

  useEffect(() => {
    let cancelled = false;
    setTaskListDataSource([]);
    if (classifWork != 2 && (classifWork != 1 || !contrNo || !taskDate)) return;
    if (cachedTasks) {
      setTaskListDataSource(cachedTasks);
      return;
    }

    const params = new URLSearchParams({ div });
    if (classifWork == 1) {
      params.set("employeeNo", employeeNo);
      params.set("date", taskDate);
    }
    const endpoint = classifWork == 2
      ? "taskList/departmentWork"
      : `taskList/${encodeURIComponent(contrNo)}`;

    axios.get(`${process.env.REACT_APP_BECCO_API_URL}/api/workR/${endpoint}?${params}`)
      .then(({ data }) => {
        if (cancelled) return;
        const rows = Array.isArray(data) ? data : [];
        setTaskListDataSource(rows);
        dispatch(updateTaskList({ key: taskListKey, data: rows }));
      })
      .catch((error) => {
        if (!cancelled) console.error(error);
      });

    return () => { cancelled = true; };
  }, [classifWork, contrNo, taskDate, div, employeeNo, taskListKey, cachedTasks, dispatch]);

  const displayExpr = (item) => {
    if (item) {
      return `${classifWork == 1 ? `${item.quotNo} · ` : ""}[${item.cat}] ${item.taskCat}`;
    } else {
      return null;
    }
  };

  const onValueChanged = (e) => {
    if (e.value) {
      // setCodeNoValue(e.value);
      //   dispatch(updateCodeNo({ codeNo: e.value }));
      //   formWorkRecordRef.current.instance.updateData("codeNo", e.value);
      taskDropDownBoxRef.current.instance.option("validationStatus", "valid");
    }
  };

  const onOptionChanged = (e) => {
    if (e.name === "opened") {
      setIsTaskGridBoxOpened(e.value);
    }
  };

  const onSelectionChanged = (e) => {
    const task = e.selectedRowsData[0];
    if (task && task.taskKey !== selectedTaskKey) {
      dispatch(
        updateCodeNo({
          codeNo: [task.codeNo],
          currentDeselectedRowKeys: e.currentDeselectedRowKeys,
          quotNo: task.quotNo,
        })
      );

      setIsTaskGridBoxOpened(false);
    }

    // formWorkRecordRef.current.instance.updateData(
    //   "codeNo",
    //   e.selectedRowKeys[0]
    // );
  };

  const groupCellRender = (itemInfo) => {
    const row = itemInfo.data.items?.[0] ?? itemInfo.data.collapsedItems?.[0] ??
      taskRows.find((task) => task.taskCategoryKey === itemInfo.data.key);
    return <div>{classifWork == 1 ? `${row?.quotNo || ""} · ` : ""}{row?.cat || ""}</div>;
  };

  const contentRender = () => {
    return (
      <DataGrid
        ref={taskDropDownDataGridRef}
        keyExpr="taskKey"
        dataSource={taskRows}
        hoverStateEnabled={true}
        selectedRowKeys={selectedTaskKey ? [selectedTaskKey] : []}
        onSelectionChanged={onSelectionChanged}
        height="100%"
        showBorders={true}
        showColumnLines={true}
      >
        <Selection mode={"single"} />
        <Scrolling mode={"virtual"} showScrollbar="always" />
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <Grouping autoExpandAll={true} expandMode={"rowClick"} />
        <GroupPanel visible={false} />
        <Column
          dataField="taskCategoryKey"
          caption="Category"
          groupIndex={0}
          groupCellRender={groupCellRender}
          sortingMethod={compareTaskCategories}
        />

        <Column dataField="quotNo" caption="Quotation No." width={200} visible={classifWork == 1} />
        <Column dataField={"taskCat"} caption="Task" />
      </DataGrid>
    );
  };

  return (
    <DropDownBox
      ref={taskDropDownBoxRef}
      name="codeNo"
      value={selectedTaskKey}
      opened={isTaskGridBoxOpened}
      valueExpr="taskKey"
      displayExpr={displayExpr}
      deferRendering={false}
      placeholder="Select a value..."
      dataSource={taskRows}
      contentRender={contentRender}
      disabled={
        classifWork &&
        ((classifWork == 1 && workRecord.contrNo) || classifWork == 2)
          ? false
          : true
      }
      // readOnly={userInfo.employeeNo == currentEmployeeNo ? false : true}
      readOnly={
        userInfo.employeeNo == currentEmployee.employeeNo ? false : true
      }
      onValueChanged={onValueChanged}
      onOptionChanged={onOptionChanged}
    />
  );
}
